import { render, staticRenderFns } from "./AddProductCatagory.vue?vue&type=template&id=9cedeb5a"
import script from "./AddProductCatagory.vue?vue&type=script&lang=js"
export * from "./AddProductCatagory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports